<template>
  <el-dialog class="DetailsDialog"
             @opened="open"
             top="20px"
             width="80%"
             :close-on-click-modal="false"
             :visible.sync="dialogVisible"
             @close="close"
             append-to-body>
    <span slot="title">
      <div class="title">
        <span style="font-size: 18px; position: absolute;top: 18px; left: 20px;">任务单查看&nbsp;&nbsp;任务单号：{{task.INSTANCE}}</span>
        <span style="position: absolute;top: 45px; right: 25px;margin-top: 10px;margin-bottom: 10px;">
          <ElButtonList></ElButtonList>
        </span>
      </div>
    </span>
    <el-tabs tab-position="top"
             v-model="activeName"
             type="card"
             style="height: 100%;"
             @tab-click="onTabClick">
      <el-tab-pane label="首页"
                   name="11">
        <span slot="label"
              class="tablable">
          <div class="tab-title">首页</div>
        </span>
        <side-tags-homePage ref="sideTagsHomePage" />
      </el-tab-pane>
      <el-tab-pane label="详情"
                   name="0">
        <span slot="label"
              class="tablable">
          <div class="tab-title">基本信息</div>
        </span>
        <side-tags-details ref="details" />
      </el-tab-pane>
      <!-- <el-tab-pane label="逾期" name="12">
				<span slot="label" class="tablable">
					<div class="tab-title">任务逾期</div>
				</span>
				<side-tags-overdue />
			</el-tab-pane> -->
      <el-tab-pane label="补充说明"
                   name="1">
        <span slot="label"
              class="tablable">
          <div class="tab-title">补充说明</div>
        </span>
        <side-tag-sreplenish />
      </el-tab-pane>
      <el-tab-pane label="跟踪记录"
                   name="2">
        <span slot="label"
              class="tablable">
          <div class="tab-title">跟踪记录</div>
        </span>
        <side-tags-track />
      </el-tab-pane>
      <el-tab-pane label="子任务"
                   name="3">
        <span slot="label"
              class="tablable">
          <div class="tab-title">子任务</div>
        </span>
        <side-tags-subtask />
      </el-tab-pane>
      <el-tab-pane label="任务总结"
                   name="4"> <span slot="label"
              class="tablable">
          <div class="tab-title">任务总结</div>
        </span>
        <side-tags-summary />
      </el-tab-pane>
      <el-tab-pane label="工作记录"
                   name="5">
        <span slot="label"
              class="tablable">
          <div class="tab-title">工作记录</div>
        </span>
        <side-tags-record />
      </el-tab-pane>
      <el-tab-pane label="任务关联"
                   name="6">
        <span slot="label"
              class="tablable">
          <div class="tab-title">任务关联</div>
        </span>
        <side-tags-relation />
      </el-tab-pane>
      <!-- <el-tab-pane label="任务计划" name="7">
				                                                                <span slot="label" class="tablable">
				                                                                                        <div class="iconfont icon-buchongziliao"></div>
				                                                                                        <div class="tab-title">任务计划</div>
				                                                                                        </span>
				                                                                <side-tags-plan></side-tags-plan>
				                                                            </el-tab-pane> -->
      <el-tab-pane label="聊天记录"
                   name="8">
        <span slot="label"
              class="tablable">
          <div class="tab-title">聊天记录</div>
        </span>
        <side-tags-i-m ref="sideTagsIm"></side-tags-i-m>
      </el-tab-pane>
      <el-tab-pane label="干系人"
                   name="9">
        <span slot="label"
              class="tablable">
          <div class="tab-title">干系人</div>
        </span>
        <side-tags-stakeholder></side-tags-stakeholder>
      </el-tab-pane>
      <!-- <el-tab-pane label="表单信息" name="10">
				                                                                                    <span slot="label" class="tablable">
				                                                                                        <div class="iconfont icon-liucheng"></div>
				                                                                                        <div class="tab-title">表单信息</div>
				                                                                                        </span>
				                                                                                    <side-tags-form></side-tags-form>
				                                                                                </el-tab-pane> -->
      <!-- <el-tab-pane label="流程信息" name="11">
				                    <span slot="label" class="tablable">
				                                                                                        <div class="tab-title">流程信息</div>
				                                                                                        </span>
				                    <side-tags-workflow-shceme></side-tags-workflow-shceme>
				                </el-tab-pane> -->
      <el-tab-pane :label="businessTabName"
                   name="10"
                   :v-show="businessTabName!=''">
        <span slot="label"
              class="tablable">
          <div class="tab-title">{{businessTabName}}</div>
        </span>
        <BusinessDetail></BusinessDetail>
      </el-tab-pane>
      <el-tab-pane label="任务计划"
                   name="13">
        <span slot="label"
              class="tablable">
          <div class="tab-title">任务计划</div>
        </span>
        <side-tags-plan :task="task"></side-tags-plan>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import ElButtonList from "./ElButtonList.vue";
import SideTagsHomePage from "./SideTagsHomePage.vue";
import SideTagsDetails from "./SideTagsDetails.vue";
import SideTagSreplenish from "./SideTagSreplenish.vue";
import SideTagsTrack from "./SideTagsTrack.vue";
import SideTagsSubtask from "./SideTagsSubtask.vue";
import SideTagsSummary from "./SideTagsSummary.vue";
import SideTagsRecord from "./SideTagsRecord.vue";
import SideTagsRelation from "./SideTagsRelation.vue";
import SideTagsPlan from "./NewSideTagsPlan/SideTagsPlan.vue";
import SideTagsIM from "./SideTagsIM.vue";
import SideTagsStakeholder from "./SideTagsStakeholder.vue";
// import SideTagsForm from './SideTagsForm.vue';
import SideTagsWorkflowShceme from "./SideTagsWorkflowShceme.vue";
import SideTagsOverdue from "./SideTagsOverdue.vue";
import BusinessDetail from "../../basicTask/BusinessDetail.vue";
import { AddTaskViewHistory } from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  components: {
    ElButtonList,
    SideTagsHomePage,
    SideTagsDetails,
    SideTagSreplenish,
    SideTagsTrack,
    SideTagsSubtask,
    SideTagsSummary,
    SideTagsRecord,
    SideTagsRelation,
    SideTagsPlan,
    SideTagsIM,
    SideTagsStakeholder,
    SideTagsOverdue,
    BusinessDetail,
    // SideTagsForm,
    SideTagsWorkflowShceme
  },
  data() {
    return {
      businessTabName: "",
      dialogVisible: false,
      activeName: "11"
    };
  },
  computed: {
    task() {
      return this.$store.state.task.curTask;
    }
  },
  watch: {
    task: function(newvalue) {
      if (!newvalue) return;
      this.businessTabName = newvalue.TASKTYPENAME;
    }
  },
  methods: {
    evaTask() {
      //评价
    },
    acceptTaskHandle() {
      //评价
    },
    open() {
      // this.$store.dispatch("getAllTemplate").then((res) => {});
      this.$refs.details.initalTask();
      this.$refs.sideTagsIm.initalTask();
    },
    close() {
      this.$refs.sideTagsHomePage.stop();
    },
    // imClick(){
    // 	console.log('im')
    // },
    closeTag: function() {
      this.$store.dispatch("changeTaskDetailShow", false);
    },
    onTabClick: function(tab) {
      // console.log(tab);
      this.$store.dispatch("changetabIndex", tab.name);
    },
    openDialog(row) {
      // this.$store.dispatch("changeCurTask", row);
      this.dialogVisible = true;
      let pars = {
        TaskId: row.ID,
        Person: {
          ID: cookieUser.userId,
          NAME: cookieUser.realName,
          DEPTID: cookieUser.departmentId,
          DEPTNAME: cookieUser.departmentName,
          COMPANYID: cookieUser.companyId,
          COMPANYNAME: cookieUser.companyName
        }
      };
      AddTaskViewHistory(pars).then(pmevent => {});
      this.$store.state.task.curTask = Object.assign({}, row);
    }
  }
};
</script>
<style lang="less">
.DetailsDialog {
  .el-dialog__body {
    padding: 0px 0px;
    font-size: 16px;
  }

  .el-tabs__header {
    margin: 0px 15px 0px 15px;
    padding: 0px 0px 0px 0px;
  }

  .Details {
    margin: 15px 0px 0px 20px;
  }

  .el-tabs__item {
    color: #929baa;
  }

  .el-tabs--card > .el-tabs__header {
    border-bottom: 0px solid #e4e7ed;
  }

  .is-active {
    border-bottom: 3px solid transparent;
  }

  .el-tabs__content {
    background: #f2f3f5;
  }

  .el-tabs__header .is-top {
    font-size: 16px;
    letter-spacing: 2px; // color: #2b7cff;
    // color: #959ca6;s
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item {
    // border-bottom: 0px solid transparent;
    border-left: 0px solid #e4e7ed;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: 0px solid #e4e7ed;
  }

  .el-tabs__item .is-top .is-active {
    border-bottom: 4px solid #2b7cff;
  }

  .el-tabs__item.is-active {
    color: #2b7cff;
    border-bottom: 4px solid #2b7cff;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom: 3px solid #2b7cff;
  }

  height: 100%; // overflow: hidden;

  .el-form {
    text-align: left;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .rightPadding {
    box-sizing: border-box;
    padding-right: 20px;
  }

  .selectInput {
    display: inline-block;
  }

  .workFlow {
    margin-right: 20px;
    color: red;
    font-size: large;
  }

  .list {
    max-height: 600px;
  }

  .createTaskForm {
    margin-bottom: 20px;
    width: 99%;
  }

  .title {
    height: 60px !important;

    .el-button {
      margin-left: 0px;
    }
  }
}
</style>
